import { useState } from "react";
import { format } from "date-fns";

export default function TaskModal({
  isOpen,
  onClose,
  selectedDate,
  tasks,
  onAddTask,
  onRemoveTask,
  onToggleTask,
}) {
  const [newTaskText, setNewTaskText] = useState("");

  if (!isOpen) return null;

  const handleAddTask = () => {
    if (newTaskText.trim()) {
      onAddTask(newTaskText.trim(), selectedDate);
      setNewTaskText("");
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleAddTask();
    }
  };

  const handleRemoveCompleted = () => {
    tasks
      .filter((t) => t.completed)
      .forEach((task) => {
        onRemoveTask(task.id);
      });
  };

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      onClick={onClose}
    >
      <div
        className="bg-gray-800 rounded-xl p-6 w-96 max-w-[90vw] shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="bg-amber-600 rounded-t-xl -m-6 mb-4 p-4">
          <h2 className="text-white text-xl font-bold text-center uppercase">
            {format(selectedDate, "EEEE, MMMM d")}
          </h2>
        </div>

        <div className="space-y-3 mb-4">
          {tasks.length === 0 ? (
            <p className="text-gray-400 text-center py-8">No tasks for today</p>
          ) : (
            tasks.map((task) => (
              <div key={task.id} className="flex items-center gap-3">
                <button
                  onClick={() => onToggleTask(task.id, task.completed)}
                  className={`w-5 h-5 rounded border-2 flex items-center justify-center transition-colors ${
                    task.completed
                      ? "bg-amber-600 border-amber-600"
                      : "bg-transparent border-amber-600"
                  }`}
                >
                  {task.completed && (
                    <svg
                      className="w-3 h-3 text-white"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                  )}
                </button>
                <span
                  className={`flex-1 text-white ${
                    task.completed ? "line-through text-gray-500" : ""
                  }`}
                >
                  {task.text}
                </span>
                <button
                  onClick={() => onRemoveTask(task.id)}
                  className="text-gray-400 hover:text-red-400 text-2xl font-light leading-none transition-colors"
                >
                  ×
                </button>
              </div>
            ))
          )}
        </div>

        <div className="flex gap-3">
          <input
            type="text"
            value={newTaskText}
            onChange={(e) => setNewTaskText(e.target.value)}
            onKeyPress={handleKeyPress}
            placeholder="Add new task..."
            className="flex-1 bg-gray-700 text-white px-4 py-2 rounded-xl border border-gray-600 focus:outline-none focus:border-amber-600"
          />
        </div>

        <div className="flex gap-3 mt-4">
          <button
            onClick={handleAddTask}
            className="w-full bg-amber-600 hover:bg-amber-700 text-white font-bold py-2 px-4 rounded-xl transition-colors uppercase"
          >
            Add
          </button>
        </div>
      </div>
    </div>
  );
}
